(function () {
    let previouslyFocusedElement = null;

    function openDrawer(id) {
        const drawer = document.getElementById(id);
        if (drawer) {
            previouslyFocusedElement = document.activeElement;
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            drawer.querySelector('.feedback-drawer__close')?.focus();
        }
    }

    function closeDrawer(drawer) {
        if (drawer) {
            drawer.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
            if (previouslyFocusedElement instanceof HTMLElement) previouslyFocusedElement.focus();
        }
    }

    function handleMeasurementImageError(image) {
        const drawer = image.closest('.product-measurements-drawer');
        const imageContainer = image.closest('.product-measurements-image');
        image.remove();
        if (imageContainer) imageContainer.hidden = true;
        if (drawer && !drawer.querySelector('[data-measurement-html]')?.innerHTML.trim()) {
            document.querySelectorAll('[data-drawer-trigger="product-measurements"]').forEach((trigger) => {
                trigger.hidden = true;
            });
        }
    }

    function updateMeasurements(drawer, variantId) {
        const dataElement = drawer.querySelector('[data-product-measurements-json]');
        if (!dataElement) return;

        let data;
        try {
            data = JSON.parse(dataElement.textContent);
        } catch (error) {
            console.error('Unable to read product measurement data.', error);
            return;
        }

        const variant = data.variants.find((item) => String(item.id) === String(variantId));
        if (!variant) return;

        const imageUrl = variant.imageUrl || data.product.imageUrl;
        const imageAlt = variant.imageUrl ? variant.imageAlt : data.product.imageAlt;
        const measurementHtml = variant.html || data.product.html;
        const imageContainer = drawer.querySelector('.product-measurements-image');
        const textContainer = drawer.querySelector('.product-measurements-text');
        const htmlContainer = drawer.querySelector('[data-measurement-html]');
        const sizeContainer = drawer.querySelector('.product-measurements-selected-size');
        const sizeValue = drawer.querySelector('[data-measurement-size]');

        imageContainer.replaceChildren();
        imageContainer.hidden = !imageUrl;
        if (imageUrl) {
            const image = document.createElement('img');
            image.src = imageUrl;
            image.alt = imageAlt || '';
            image.loading = 'lazy';
            image.className = 'product-drawer-measurement-image';
            image.addEventListener('error', () => handleMeasurementImageError(image), { once: true });
            imageContainer.append(image);
        }

        htmlContainer.innerHTML = measurementHtml || '';
        textContainer.hidden = !measurementHtml;
        sizeContainer.hidden = !data.sizeOptionPosition;
        sizeValue.textContent = variant.size || '';

        document.querySelectorAll('[data-drawer-trigger="product-measurements"]').forEach((trigger) => {
            trigger.hidden = !imageUrl && !measurementHtml;
        });
    }

    function initProductDrawers() {
        document.querySelectorAll('.product-measurements-image img').forEach((image) => {
            image.addEventListener('error', () => handleMeasurementImageError(image), { once: true });
        });

        document.addEventListener('click', (e) => {
            // Opening
            const trigger = e.target.closest('[data-drawer-trigger]');
            if (trigger) {
                const targetId = `${trigger.dataset.drawerTrigger}-drawer`;
                openDrawer(targetId);
                return;
            }

            // Closing from close buttons
            const closeBtn = e.target.closest('[data-drawer-close]');
            if (closeBtn) {
                const drawer = closeBtn.closest('.product-drawer');
                closeDrawer(drawer);
                return;
            }

            // Closing from overlay
            if (e.target.matches('.feedback-drawer__overlay')) {
                const drawer = e.target.closest('.product-drawer');
                closeDrawer(drawer);
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                const openDrawerEl = document.querySelector('.product-drawer.is-open');
                closeDrawer(openDrawerEl);
            }

            if (e.key === 'Tab') {
                const openDrawerEl = document.querySelector('.product-drawer.is-open');
                if (!openDrawerEl) return;
                const focusable = Array.from(openDrawerEl.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
                if (!focusable.length) return;
                const first = focusable[0];
                const last = focusable[focusable.length - 1];
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        });

        document.addEventListener('variant:update', (event) => {
            const variantId = event.detail?.resource?.id;
            if (!variantId) return;
            document.querySelectorAll('.product-measurements-drawer').forEach((drawer) => updateMeasurements(drawer, variantId));
        });
    }

    // Run once on load
    initProductDrawers();
})();
